import React from 'react';
import {aceCustId} from '../../../context/context';
import TailorYourForm from '../common/tailor-your-form';
import PreviousNext from './previous-next';
import OpenInNewLink from '../../../libs/react-components-admin/link/open-in-new-link';

const Step3 = ({onPreviousClicked}) => {

  return <>
    <div className="row mb-3">
      <div className="col">
        <TailorYourForm/>
      </div>
    </div>
    <div className="row mb-4">
      <div className="col">
        You can also create a <OpenInNewLink href={'https://' + aceCustId + '/admin/menus'}>menu
        entry</OpenInNewLink> for the page.
      </div>
    </div>
    <PreviousNext hideNext={true} onPreviousClicked={() => onPreviousClicked()}/>
  </>;
};

export default Step3;
